import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-wo_032",
  "use": "icon-wo_032-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-wo_032\"><defs><style>#icon-wo_032 .cls-1{fill:none;opacity:0;}</style></defs><g id=\"icon-wo_032_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-wo_032_icon\"><rect class=\"cls-1\" width=\"24\" height=\"24\" /><path class=\"cls-2\" d=\"M3,3V20H21V3ZM19,18H5V15H19Zm0-5H5V10H19Zm0-5H5V5H19Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol